import React from 'react';
import { css } from '../styled-system/css/index';
import { Link } from 'react-router-dom';
import SEO, { SITE_URL } from '../components/SEO';
const IMG_HERO = (process.env.PUBLIC_URL || '') + '/EZI_hero3.png';
const IMG_COST = (process.env.PUBLIC_URL || '') + '/EZI_reduce_cost-1024x680.png';
const IMG_DOWNTIME = (process.env.PUBLIC_URL || '') + '/EZI_reduce_downtime-1024x680.png';
const IMG_TODO = (process.env.PUBLIC_URL || '') + '/EZI_to_do-1024x680.png';
const IMG_CTA_BG = (process.env.PUBLIC_URL || '') + '/EZI_CTA2rv.png';
const IMG_WHITE_LOGO = (process.env.PUBLIC_URL || '') + '/EZI_Logo_small.png';
// Feature icons
const ICON_LIGHTWEIGHT = (process.env.PUBLIC_URL || '') + '/3d-home-icon3.png';
const ICON_JUSTFIT = (process.env.PUBLIC_URL || '') + '/3d-home-icon1.png';
const ICON_AESTHETICS = (process.env.PUBLIC_URL || '') + '/3d-home-icon2.png';
const pageStyle = css({
  maxW: '1100px',
  m: '40px auto',
  p: '0 20px',
});

const sectionStyle = css({
  m: '64px 0',
});

const gridStyle = css({
  display: 'grid',
  gap: '32px',
  gridTemplateColumns: '1.2fr 1fr',
  alignItems: 'center',
  selectors: { '@media (max-width: 900px)': { gridTemplateColumns: '1fr' } },
});

const titleStyle = css({
  fontSize: '2.4rem',
  mb: '12px',
  color: '#111827',
});

const h2Style = css({
  fontSize: '2rem',
  mb: '10px',
  color: '#197bbd',
});

const leadStyle = css({
  fontSize: '1.1rem',
  color: '#6b7280',
});

const buttonsStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  mt: '18px',
  flexWrap: 'wrap',
});

const ctaStyle = css({
  textDecoration: 'none',
  p: '12px 18px',
  borderRadius: '24px',
  border: 'none',
  bg: '#197bbd',
  color: '#fff',
  fontWeight: 700,
});

const ghostStyle = css({
  textDecoration: 'none',
  p: '12px 18px',
  borderRadius: '24px',
  border: '1px solid #197bbd',
  color: '#197bbd',
  fontWeight: 700,
});

const mediaStyle = css({
  border: '1px solid #e5e7eb',
  borderRadius: '10px',
  overflow: 'hidden',
  bg: '#fff',
});

const imgStyle = css({
  w: '100%',
  h: 'auto',
  display: 'block',
  borderRadius: '10px',
  border: '1px solid #e5e7eb',
});

const heroWrapStyle = css({
  m: 0,
  p: '120px 20px',
  w: '100vw',
  minH: '560px',
  ml: 'calc(50% - 50vw)',
  mr: 'calc(50% - 50vw)',
  borderRadius: 0,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundColor: '#1f2937',
  display: 'grid',
  placeItems: 'center',
  textAlign: 'center',
  color: '#fff',
  overflow: 'hidden',
});

const heroCardStyle = css({
  maxW: '820px',
  w: '100%',
});

const heroTitleStyle = css({
  fontSize: '3rem',
  lineHeight: 1.1,
  m: '0 0 12px',
  color: '#fff',
  selectors: { '@media (max-width: 640px)': { fontSize: '2.25rem' } },
});

const heroLeadStyle = css({
  fontSize: '1.15rem',
  m: 0,
  color: '#f1f1f1',
});

const heroButtonsStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  mt: '18px',
  flexWrap: 'wrap',
  justifyContent: 'center',
});

const centerStyle = css({
  textAlign: 'center',
  m: '0 auto 16px',
});

const videoStyle = css({
  position: 'relative',
  w: '100%',
  paddingTop: '56.25%',
  borderRadius: '12px',
  overflow: 'hidden',
  border: '1px solid #e5e7eb',
  bg: '#000',
});

const frameStyle = css({
  position: 'absolute',
  inset: 0,
  w: '100%',
  h: '100%',
  border: 0,
});

const twoColStyle = css({
  display: 'grid',
  gap: '28px',
  gridTemplateColumns: '1fr 1fr',
  alignItems: 'center',
  selectors: { '@media (max-width: 900px)': { gridTemplateColumns: '1fr' } },
});

const bgWrapStyle = css({
  m: '64px 0',
  p: '80px 20px',
  w: '100vw',
  minH: '720px',
  ml: 'calc(50% - 50vw)',
  mr: 'calc(50% - 50vw)',
  borderRadius: 0,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundColor: '#1f2937',
  color: '#fff',
  overflow: 'hidden',
});

const threeColsStyle = css({
  maxW: '1100px',
  m: '0 auto 36px',
  display: 'grid',
  gap: '24px',
  gridTemplateColumns: 'repeat(3, 1fr)',
  selectors: { '@media (max-width: 900px)': { gridTemplateColumns: '1fr' } },
});

const featureStyle = css({
  textAlign: 'center',
  p: '18px',
  borderRadius: '12px',
  bg: 'rgba(0,0,0,0.25)',
  border: '1px solid rgba(255,255,255,0.2)',
});

const featureTitleStyle = css({
  m: '0 0 8px',
  fontSize: '1.25rem',
  color: '#fff',
});

const featureLeadStyle = css({
  m: 0,
  color: '#e9e9e9',
});

const logoMarkStyle = css({
  h: '60px',
  w: 'auto',
  display: 'block',
  m: '0 auto 12px',
});

const iconStyle = css({
  h: '56px',
  w: '56px',
  objectFit: 'contain',
  display: 'block',
  m: '0 auto 10px',
});

const Home = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Store',
    name: 'EZIBLANK USA',
    url: SITE_URL,
    image: `${SITE_URL}/EZI_hero3.png`,
    description:
      'EZIBLANK USA sells server rack blanking panels, brush panels, EziWall airflow barriers, and data center airflow management products.',
    areaServed: 'US',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Server rack airflow management products',
      itemListElement: [
        {
          '@type': 'OfferCatalog',
          name: 'Server rack blanking panels',
        },
        {
          '@type': 'OfferCatalog',
          name: 'Rack brush panels and airflow barriers',
        },
      ],
    },
  };

  return (
    <div className={pageStyle}>
      <SEO
        title="Server Rack Blanking Panels and Data Center Airflow Products | EZIBLANK USA"
        description="Shop EziBlank server rack blanking panels, 19 inch and 23 inch rack airflow panels, brush panels, and EziWall airflow barriers for data centers."
        path="/"
        jsonLd={jsonLd}
      />
      {/* HERO with centered text, subtext, and button over background */}
      <section className={heroWrapStyle} style={{ backgroundImage: `url(${IMG_HERO})` }}>
        <div className={heroCardStyle} style={{ backdropFilter: 'blur(2px)' }}>
          <h1 className={heroTitleStyle} style={{ textShadow: '0 2px 8px rgba(0,0,0,0.35)' }}>Server Rack Blanking Panels for Better Data Center Airflow</h1>
          <p className={heroLeadStyle}>
            To maximize your data center's efficiency, blanking panels are essential.
            Reduce bypass air, improve cooling performance, and cut energy costs with EziBlanks.
          </p>
          <div className={heroButtonsStyle}>
            <Link className={ctaStyle} to="/products">Browse Products</Link>
          </div>
        </div>
      </section>

      {/* Embedded video at top of the second section */}
      <section className={sectionStyle}>
        <div className={videoStyle} aria-label="EziBlanks overview video">
          <iframe
            className={frameStyle}
            src="https://www.youtube-nocookie.com/embed/sPHwjLO5HBc"
            title="EziBlanks Overview"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </section>

      {/* Alternating image/text rows (Pic→Text, then Text→Pic, then Pic→Text) */}
      <section className={sectionStyle}>
        <div className={twoColStyle}>
          <div className={mediaStyle}><img className={imgStyle} src={IMG_COST} alt="Reduce cooling costs with effective blanking" /></div>
          <div>
            <h2 className={h2Style}>Reduce Cooling Cost with Rack Blanking Panels</h2>
            <p className={leadStyle}>
              Energy costs account for 20% to 40% of the data center's operational costs. EziBlanks can help you reduce those costs by better airflow management, eliminate hotspots and prevent recirculating of hot air through your servers.
            </p>
          </div>
        </div>
      </section>

      <section className={sectionStyle}>
        <div className={twoColStyle} style={{ gridAutoFlow: 'dense' }}>
          <div className={mediaStyle} style={{ gridColumn: 2 }}><img className={imgStyle} src={IMG_DOWNTIME} alt="Lower downtime risk with stable inlet temperatures" /></div>
          <div style={{ gridColumn: 1 }}>
            <h2 className={h2Style}>Reduce Equipment Downtime in Server Racks</h2>
            <p className={leadStyle}>
              Equipment failures and downtime can wreak havoc on your productivity and revenue. EziBlanks significantly reduce the risk of downtime by maintaining proper airflow and preventing thermal stress on your servers. Experience increased equipment reliability, improved lifespan, and minimized disruptions, keeping your operations running smoothly.
            </p>
          </div>
        </div>
      </section>

      <section className={sectionStyle}>
        <div className={twoColStyle}>
          <div className={mediaStyle}><img className={imgStyle} src={IMG_TODO} alt="Simple to implement across your racks" /></div>
          <div>
            <h2 className={h2Style}>Easy Installation for 19 Inch and 23 Inch Racks</h2>
            <p className={leadStyle}>
              We understand that time is of the essence in the fast-paced data center environment. That's why EziBlank panels are designed for effortless installation and customization. EziBlanks are easy to install, requires no tools, lightweight, snap apart design for any range of sizing and aesthetically pleasing inside your server cabinets. With a range of sizes, colors and configurations available, our panels seamlessly integrate into your existing infrastructure. Enhance performance without the hassle!
            </p>
          </div>
        </div>
      </section>

      {/* Centered video toward the end NEEDS CENTERED TITLE AND SUBTEXT */}
      <section className={sectionStyle}>
        <div className={centerStyle}>
          <h2 className={h2Style}>EZI as... 1,2,3</h2>
          <p className={leadStyle}>
            EziBlank panels are quick and easy to install, helping ensure proper airflow in data racks.
          </p>
        </div>
        <div className={videoStyle} aria-label="Customer results and walkthrough">
          <iframe
            className={frameStyle}
            src="https://www.youtube-nocookie.com/embed/iLEBAp7y5sY"
            title="Customer Results"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </section>

      {/* Reuse same background for features row + CTA row */}
      <section className={bgWrapStyle} style={{ backgroundImage: `url(${IMG_CTA_BG})` }}>
        <div className={threeColsStyle}>
          <div className={featureStyle}>
            <img className={iconStyle} src={ICON_LIGHTWEIGHT} alt="Lightweight icon" loading="lazy" />
            <h3 className={featureTitleStyle}>Lightweight</h3>
            <p className={featureLeadStyle}>
              In EziBlank, we believe efficiency is a holistic concept where less is more. Lightweight materials are our first choices when designing new products. Take our 6U blanking panel as an example, it is the lightest in its class yet still offers superior performance and usability.
            </p>
          </div>
          <div className={featureStyle}>
            <img className={iconStyle} src={ICON_JUSTFIT} alt="Just-Fit icon" loading="lazy" />
            <h3 className={featureTitleStyle}>Just-Fit</h3>
            <p className={featureLeadStyle}>
              By understanding how material works and precision engineering, we can create just-fit products that are still robust and durable. Users have found that EziBlank products are more flexible and ergonomic, and fit perfectly into their intended position.
            </p>
          </div>
          <div className={featureStyle}>
            <img className={iconStyle} src={ICON_AESTHETICS} alt="Cohesive Aesthetics icon" loading="lazy" />
            <h3 className={featureTitleStyle}>Cohesive Aesthetics</h3>
            <p className={featureLeadStyle}>
              We don't stop at just making our products work well, they have to look right. This is where cohesive aesthetic comes into our design equation. With a range of standard colour options and non-intrusive fittings, EziBlank products blend in seamlessly into data centre of different themes and designs.
            </p>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <img className={logoMarkStyle} src={IMG_WHITE_LOGO} alt="EZIBLANK" />
          <h2 className={h2Style} style={{ color: '#fff', marginBottom: '12px' }}>Unlock the true potential</h2>
          <h2 className={h2Style} style={{ color: '#fff', marginBottom: '12px' }}>of your data center today!</h2>
          <div className={buttonsStyle} style={{ justifyContent: 'center' }}>
            <Link className={ctaStyle} to="/products">Shop Now</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
